<div *ngIf="isCvcExpired()" [formGroup]="cvcDetailForm" class="row">
  <div class="col-12 col-md-9 col-lg-7">
    <formly-form [form]="cvcDetailForm" [fields]="fields" />
  </div>

  <div class="col-md-3 col-lg-5">
    <button type="submit" class="btn btn-primary" (click)="renewCVCDetails()">
      {{ 'checkout.account.confirm.button.label' | translate }}
    </button>
  </div>
</div>
